import React from 'react';

import { FieldArray, FormikContext, setIn, getIn } from 'formik';
import cloneDeep from 'lodash/cloneDeep';

class FormFieldArray extends React.Component {
  // connected to https://github.com/jaredpalmer/formik/issues/988
  // TODO: remove after fix in formik

  static contextType = FormikContext;
  push = (value) =>
    this.updateArrayField(
      (array) => [
        ...(array || []),
        ...(Array.isArray(value) ? value.map(cloneDeep) : [cloneDeep(value)]),
      ],
      false,
      false
    );

  updateArrayField = (fn, alterTouched, alterErrors) => {
    const {
      name,
      validateOnChange = this.props.validateOnChange ||
        this.context.validateOnChange,
    } = this.props;

    const { setFormikState, validateForm } = this.context;
    setFormikState(
      (prevState) => ({
        ...prevState,
        values: setIn(
          prevState.values,
          name,
          fn(getIn(prevState.values, name))
        ),
        errors: alterErrors
          ? setIn(prevState.errors, name, fn(getIn(prevState.errors, name)))
          : prevState.errors,
        touched: alterTouched
          ? setIn(prevState.touched, name, fn(getIn(prevState.touched, name)))
          : prevState.touched,
      }),
      () => {
        if (validateOnChange) {
          validateForm();
        }
      }
    );
  };

  render() {
    const { children, validateOnChange, ...props } = this.props;
    const value = getIn(this.context.values, this.props.name);
    const error = getIn(this.context.errors, this.props.name);

    return (
      <FieldArray
        name={this.props.name}
        validateOnChange={validateOnChange || this.context.validateOnChange}
        render={({ name, ...arrayHelpers }) => {
          return children({
            ...props,
            form: this.context,
            name,
            value,
            ...arrayHelpers,
            push: this.push,
            error: Array.isArray(error) ? null : error,
          });
        }}
      />
    );
  }
}
export default FormFieldArray;
